import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { isSupported } from 'twilio-video';
import UnavailableRoom from "../components/rooms/unavailable_room";
import PreviewRoom from "../components/rooms/preview_room";
import PreloadRoom from "../components/rooms/preload_room";
import VideoConference from "../components/rooms/video_conference";
import ClosedRoom from "../components/rooms/closed_room";

class Room extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_available: null,
      connected: false,
      room_evaluation: false,
      room: null,
      holderToken: null,
    };
    this.isSupported = true;
    this.deviceOrigin = (typeof(window["ReactNativeWebView"]) !== "undefined") ? 'native' : 'web';
    console.log(this.isSupported);
    console.log(this.deviceOrigin);
    this.connectToRoom = this.connectToRoom.bind(this);
    this.disconnectFromRoom = this.disconnectFromRoom.bind(this);
  }

  componentDidMount() {
    if (this.isSupported) {
      fetch(`/api/v1/rooms/${this.props.token}`, {
        headers: { "Content-Type": "application/json; charset=utf-8" },
        method: 'GET',
      }).then(response => {
        if (response.status === 404) {
          throw new Error(response.status.toString())
        }
        return response.json();
      }).then(data => this.setState({ room: data, holderToken: data.token, is_available: true })
      ).catch(error => {
        if (error.message.includes("404")) {
          // 404 is not room created, so we create the room
          this.createRoom();
        }
      });
    }
  }

  createRoom() {
    const csrf_token = document.querySelector('meta[name=csrf-token]').content;
    fetch(`/api/v1/rooms`, {
      headers: { "Content-Type": "application/json; charset=utf-8", "X-CSRF-Token": csrf_token },
      method: "POST",
      body: JSON.stringify({
        token: this.props.token,
      })
    }).then(response => response.json().then(json => ({ body: json, status: response.status })))
      .then(response => {
        if (response.status === 201) {
          this.setState({ room: response.body, holderToken: response.body.token, is_available: true });
        } else if (response.status === 422) {
          console.log(422, response.body);
          if (Array.isArray(response.body) && response.body[0] === "not_available") {
            this.setState({ is_available: false });
          } else {
            alert("Ha ocurrido un error!");
          }
        } else {
          console.log("UNK", response);
        }
      });
  }

  connectToRoom() {
    // if we are connecting from the webview, we need to directly go to the evaluation view
    if (this.deviceOrigin === 'native') {
      const self = this;
      setTimeout(function() { self.setState({ connected: false, room_evaluation: true }); }, 3000);
      // We send to Android the message with the tokens
      window.ReactNativeWebView.postMessage(JSON.stringify(
        { holderToken: this.state.holderToken, roomToken: this.props.token, conversationId: this.props.conversationId }
      ));
    } else {
      // this is the general case, we go to video conference room
      this.setState({ connected: true, is_available: true });
    }
  }

  disconnectFromRoom() {
    this.setState({ connected: false, room_evaluation: true });
  }

  goBack() {
    window.history.go(-1);
    return false;
  }

  /**
   * Use to show a preview screen for web users. This should be accesible only when the room is not connected.
   */
  shouldPreviewRoom() {
    return !this.state.connected && this.state.is_available && this.deviceOrigin !== 'native' && !this.state.room_evaluation;
  }

  /**
   * Use to show a loading screen for native users. This should be accesible only when the room is not connected.
   * It's the same idea as the PreviewRoom but for native users.
   */
  shouldPreloadRoom() {
    return !this.state.connected && this.state.is_available && this.deviceOrigin === 'native' && !this.state.room_evaluation;
  }

  render() {
    if (!this.isSupported) {
      return (
        <div className="box_general rooms__unavailable">
          <div className="header_box">
            <h2 className="d-inline-block">Videoconferencia</h2>
            <hr/>
          </div>

          <div className="list_general text-center">
            <i className={"fa fa-clock margin_20"}/>
            <h3 className={"h3"}>No compatible</h3>
            <p className={"rooms__unavailable-message"}>
              Hemos detectado que nuestro sistema de videoconferencias no es compatible con tu navegador/dispositivo que 
              est&aacute;s utilizando. Te recomendamos utilizar el navegador web <a href="https://www.google.com/intl/es/chrome/">Google Chrome</a> o <a href="https://www.mozilla.org/es-CL/firefox/new/">Firefox</a>.
            </p>
            <p className={"margin_20"}>
              <a href="#" className={"btn_1"} onClick={this.goBack}>VOLVER</a>
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          { this.state.is_available === false && <UnavailableRoom appointment={this.props.appointment} holder={this.props.holder}/> }
          { this.shouldPreviewRoom() && <PreviewRoom appointment={this.props.appointment} holder={this.props.holder} holderToken={this.state.holderToken} roomToken={this.props.token} connectRoomHandler={this.connectToRoom} site={this.props.site}/> }
          { this.shouldPreloadRoom() && <PreloadRoom appointment={this.props.appointment} holder={this.props.holder} connectRoomHandler={this.connectToRoom} /> }
          {
            this.state.connected && this.state.is_available && !this.state.room_evaluation &&
            <VideoConference appointment={this.props.appointment} holder={this.props.holder} holderToken={this.state.holderToken} roomToken={this.props.token} onHangUp={this.disconnectFromRoom}/>
          }
          {
            this.state.room_evaluation &&
            <ClosedRoom holder={this.props.holder} appointment={this.props.appointment} roomToken={this.props.token} site={this.props.site} closedRoomImg ={this.props.closedRoomImg} />
          }
        </div>
      );
    }
  }
}

Room.propTypes = {
  token: PropTypes.string.isRequired,
  appointment: PropTypes.shape({
    consultation: PropTypes.string.isRequired,
    patient: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    professional: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    start_time: PropTypes.string.isRequired,
  }).isRequired,
  holder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  conversationId: PropTypes.string.isRequired,
};

export default Room;
